module.exports = __webpack_public_path__ + "img/location.5c7d644d.png";